/*
*
* File JS componente Hero Section
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './prize-slider.scss';
import Swiper from "swiper";

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const prizeSlider = () => {
    let prizeSwiper = new Swiper(document.querySelector('.prizeSwiper'), {
        speed: 600,
        spaceBetween: 20,
        // allowTouchMove: false,
        breakpoints: {
            0: {
                slidesPerView: 1.3,
            },
            425: {
                slidesPerView: 'auto',
            }
        }
    });
}

export default prizeSlider;

//--------------------------------------------------------------------//
